import { render } from "./EstadoTag.vue?vue&type=template&id=17ab7d20&ts=true"
import script from "./EstadoTag.vue?vue&type=script&lang=ts"
export * from "./EstadoTag.vue?vue&type=script&lang=ts"

import exportComponent from "/tmp/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__